module.exports = __webpack_public_path__ + "vue/img/icon-04.2547c2de.png";